export default __webpack_public_path__ + "static/Huawei-a8266b48b4a63e04a7ff1c0ef002a799.png";